import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 23 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M19.843 3.595c1.765 1.766 2.56 3.527 2.592 3.601a.75.75 0 0 1 0 .61c-.032.074-.827 1.834-2.592 3.6C17.491 13.756 14.52 15 11.25 15s-6.24-1.243-8.593-3.594C.892 9.64.097 7.88.065 7.806a.75.75 0 0 1 0-.61c.029-.071.827-1.835 2.592-3.6C5.009 1.242 7.98 0 11.25 0s6.24 1.243 8.593 3.595m-10.26 6.4a3 3 0 1 0 3.333-4.988 3 3 0 0 0-3.333 4.987Z"
    }, null, -1)
  ])))
}
export default { render: render }